import axios from "axios";

export default axios.create({
  baseURL: "https://gaasales.aeonsoftware.net/cit",
});
